import { useEffect, useState } from 'react';
import moment from 'moment';
import { computeLocal, SERVER_FMT } from '../../lib/clock';
import { useStage } from '../stage';

// Screen-local time from the server-anchored clock (right even when the device clock is wrong).
// On a wall the stage's synced clock is used, so every tile shows the same second.
const localMoment = (clock, stage) => {
  if (!clock?.timeZone) return moment();
  const { localStr } = stage.wall
    ? computeLocal(0, clock.timeZone, stage.now())
    : computeLocal(clock.offsetMs, clock.timeZone);
  return moment(localStr, SERVER_FMT);
};

const msToNextSecond = (nowMs) => 1000 - (((nowMs % 1000) + 1000) % 1000);

/** The time (and optionally the date) in the screen's time zone. */
export const ClockItem = ({ item, clock }) => {
  const stage = useStage();
  const {
    use24Hour = true,
    showSeconds = false,
    showDate = true,
    color = '#FFFFFF',
    background = '#111827',
  } = item.settings || {};
  const [now, setNow] = useState(() => localMoment(clock, stage));

  useEffect(() => {
    // Tick on the second boundary of the clock shown, not whenever this item mounted.
    const nowMs = () =>
      stage.wall ? stage.now() : Date.now() + (clock?.offsetMs || 0);
    let timer;
    const tick = () => {
      setNow(localMoment(clock, stage));
      timer = setTimeout(tick, msToNextSecond(nowMs()) + 5);
    };
    timer = setTimeout(tick, msToNextSecond(nowMs()) + 5);
    return () => clearTimeout(timer);
  }, [clock?.offsetMs, clock?.timeZone, stage]);

  const timeFormat =
    (use24Hour ? 'HH:mm' : 'h:mm') +
    (showSeconds ? ':ss' : '') +
    (use24Hour ? '' : ' A');

  return (
    <div
      className="absolute inset-0 flex flex-col items-center justify-center"
      style={{ background, color, gap: stage.vh(2) }}
    >
      <div
        className="font-semibold tabular-nums"
        style={{ fontSize: stage.vh(20), lineHeight: 1 }}
      >
        {now.format(timeFormat)}
      </div>
      {showDate && (
        <div style={{ fontSize: stage.vh(5), opacity: 0.8 }}>
          {now.format('dddd, D MMMM YYYY')}
        </div>
      )}
    </div>
  );
};
